/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment, useState, useContext, useEffect } from 'react';
import { Card, ProgressSteps, TextInput, Label, Grid, Icon, AuthContext, useAPI } from 'components/lib';
import Style from './creation-campaign.module.scss';

export function CampaignCreation(props){

  const context = useContext(AuthContext);
  const [name, setName] = useState(null);
  const [existName, setExistName] = useState(false);

  const campaignListByAccount = useAPI('/api/user/campListByAccount');

  useEffect(() => {
    console.log(campaignListByAccount);
    if(campaignListByAccount?.data?.length > 0 && name !== null && name !== "") {
      let campaignNameFilter = campaignListByAccount.data.filter(val => val.campaignName === name);
      if(campaignNameFilter.length) {
        setExistName(true);
      } else {
        setExistName(false);
      }
    }
  }, [campaignListByAccount, name]);

  const nameFunction = (field, value) => {
    setName(value);
  }

  return (
    <Fragment>
    
      <div style={{ marginTop: '-40px' }}>
        <ProgressSteps items={[
            { name: 'Crear', url: '/creation', completed: true },
            { name: 'Audiencia', url: '/camp-audience', completed: false },
            { name: 'Plantillas', url: '/theme', completed: false },
            { name: 'Resumen', url: '/summary', completed: false },
            { name: 'Listo', url: '/finish', completed: false },
        ]} marginRight='-15px' shadow/>
      </div>
      
      <div style={{ marginTop: '8em', width: '45%' }}>
        <div style={{ float: 'left', marginBottom: '20px' }}>
          <Label text='Nombre de la campaña' weight/>
        </div>
        <TextInput 
          name='campaignName' 
          onChange={nameFunction} 
          value={name} 
          rounded 
          border
          height={'55px'}
          valid={name === null ? null : name === "" || existName ? false : true}
        />
      </div>

      <div style={{ marginTop: '3em' }}>
        <div style={{ marginTop: '20px', display: 'flex', marginBottom: '25px' }}>
          <Label text='Tipo de Campaña' weight/>
        </div>

        <Grid cols='3'>
          <Card className={ Style.optionEmail } >
            <Icon 
              image='mail'
              size={92}
              color='brand'
            />
          </Card>
          <Card className={ Style.option }>
            <Icon 
              image='refresh-cw' 
              size={92}
              color='brand'
            />
          </Card>
          <Card className={ Style.option }>
            <Icon 
              image='book-open' 
              size={92}
              color='brand'
            />
          </Card>
        </Grid>
      </div>

      <div style={{ position: 'fixed', bottom: '2em', right: '2em' }}>
        <ProgressSteps items={[
          { name: 'Regresar', url: '/campaign', completed: false, iconLeft: 'chevron-left' },
          { name: 'Continuar', url: '/camp-audience', completed: true, iconRight: 'chevron-right', locked: !name || name === "" || existName  ? true : false, click: () => context.dispatch({ type: 'ADD_CAMPAIGN', value: { name } })},
        ]} marginRight='10px'/>
      </div>
      
    </Fragment>
  )
}